<template>
  <AdminLayout>
    <RouterView />
  </AdminLayout>
</template>

<script setup lang="ts">
import AdminLayout from '@/components/admin/AdminLayout.vue'
</script>
